import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { InputFileType, RegisterExcelInfo } from '@/coreDomainsModule/entities/inputExcelInfo';
import { InputExcelInfosRepository } from '@/coreInfrastructureModule/Repositories/InputExcelInfosRepository';

/**
 * 入力エクセルの読み込み情報を取得する(全てのファイルタイプについて取得する)
 */
export class GetInputExcelInfoUseCase {
  /**
   *  データを取得する
   * @param repository - リポジトリ
   */
  public async Execute(repository: InputExcelInfosRepository): Promise<INetworkResult<Record<InputFileType, RegisterExcelInfo>, IError>> {
    try {
      const response = await repository.get();
      if (response.status.type === 'success') {
        const useKey = response.status.data[0];
        return {
          status: {
            type: 'success',
            data: response.status.data[1][useKey], // 絶対に存在するはず
          },
        };
      } else {
        return {
          // 基本的にはここには来ない
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
